










































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { basePcList } from "./baseConfig";
import InfoRight from "./components/infoRight.vue";
import InfoBottom from "./components/infoBottom.vue";
@Component({
  components: { InfoRight, InfoBottom },
})
export default class Home extends Vue {
  public threeShowList = [
    {
      id: "5",
      name: "3601",
    },
  ];
  public ykShowList = [
    {
      id: "10",
      name: "yueke",
    },
  ];
  public yxShowList = [
    {
      id: "11",
      name: "yx360",
    },
    {
      id: "12",
      name: "yx3602",
    },
  ];
  public swShowList = [
    {
      id: "13",
      name: "sw360",
    },
  ];
  public yuekeShowList = [
    {
      id: "15",
      name: "yueke1",
    },
  ];
  public baiduShowList = [
    {
      id: "18",
      name: "baidu6",
    },
  ];
  public baidu7ShowList = [
    {
      id: "19",
      name: "baidu7",
    },
  ];
  public sougou4ShowList = [
    {
      id: "21",
      name: "sougou4",
    },
  ];
  public baidu13ShowList = [
    {
      id: "22",
      name: "baidu13",
    },
  ];
  public baidu14ShowList = [
    {
      id: "23",
      name: "baidu14",
    },
  ];
  public yuekebdShowList = [
    {
      id: "30",
      name: "yuekebd2",
    },
  ];
  public yxShowThree = [
    {
      id: "31",
      name: "yx3608",
    },
    {
      id: "32",
      name: "fs3601",
    },
    {
      id: "33",
      name: "fs3602",
    },
    {
      id: "34",
      name: "fs3603",
    },
  ];
  public fssgShow = [
    {
      id: "35",
      name: "fssg1",
    },
  ];
  public fsbdShow = [
    {
      id: "36",
      name: "fsbd2",
    },
  ];
  public sougou5ShowList = [
    {
      id: "37",
      name: "sougou5",
    },
  ];
  public pdykList = [
    {
      id: "38",
      name: "pdyk",
    },
  ];
  public swbdShow = [
    {
      id: "10001",
      name: "swbd2",
    },
  ];
  public fsbd5List = [
    {
      id: "10002",
      name: "fsbd5",
    },
  ];
  public returnShow(list, isReverse?) {
    const shows = list.some((item) => {
      return (
        this.$route.name == item.name || this.$route.query.isCom == item.id
      );
    });
    return isReverse ? !shows : shows;
  }
  public toOpen(path) {
    const arr = basePcList.filter((item) => {
      return (
        this.$route.name == item.name || this.$route.query.isCom == item.id
      );
    });
    const info = arr[0];
    let routeUrl;
    if (info) {
      routeUrl = this.$router.resolve({
        path,
        query: { isCom: info.id },
      });
    } else {
      routeUrl = this.$router.resolve({
        path,
      });
    }
    window.open(routeUrl.href, "_blank");
  }
}
